import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgAdd = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M11.2308 3.23077C11.2308 2.55 10.6808 2 10 2C9.31923 2 8.76923 2.55 8.76923 3.23077V8.76923H3.23077C2.55 8.76923 2 9.31923 2 10C2 10.6808 2.55 11.2308 3.23077 11.2308H8.76923V16.7692C8.76923 17.45 9.31923 18 10 18C10.6808 18 11.2308 17.45 11.2308 16.7692V11.2308H16.7692C17.45 11.2308 18 10.6808 18 10C18 9.31923 17.45 8.76923 16.7692 8.76923H11.2308V3.23077Z",
		fill: "#0D2976"
	})
});
export default SvgAdd;
